import { render } from "./HotspotIntro.vue?vue&type=template&id=5b4cd74a"
import script from "./HotspotIntro.vue?vue&type=script&lang=js"
export * from "./HotspotIntro.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__